import store from '@/store'
import axios from 'axios'
import userApi from '@/api/user.js'
import router from '@/router'

export default {
    async login(requestData, otpVerified) {
        try{
            let response = null
            if (otpVerified) {
                response = await userApi.login2(requestData)
            } else {
                response = await userApi.login(requestData)
            }

            if (response && response.status == 200) {
                store.commit('setPassword', requestData.password)
                this.saveUserState(response)
            }
        }catch(error){
            throw error
        }
    }, 
    async switchAccount(requestData) {
        try {
            const response = await userApi.switchAccount(requestData)
            if (response && response.status == 200) {
                this.saveUserState(response)
            }
        }catch(error){
            throw error
        }
    },  
    saveUserState(response){
        try {
            axios.defaults.headers["Authorization"] = `Bearer ${response.data.token}`
            axios.defaults.headers["session_id"] = response.data.sessionId

            let user = response.data.user

            //token details   
            localStorage.token = response.data.token            
            localStorage.refreshToken = response.data.refreshToken
            localStorage.sessionId = response.data.sessionId

            store.commit('setOnBoarded', user.onBoarded)
            store.commit('setChangedPassword', user.changedPassword)
            store.commit('setMemberCount', user.memberCount)
            store.commit('setIsLinkedAccount', user.isLinkedAccount)

            //user details
            store.commit('setUserId', user.userId) 
            store.commit('setParentUserId', user.parentUserId)
            store.commit('setUserName', user.firstName + ' ' + user.lastName) 
            store.commit('setName', user.firstName + ' ' + user.lastName) 
            store.commit('setFirstName', user.firstName)
            store.commit('setLastName', user.lastName)        
            store.commit('setEmail', user.email)
            store.commit('setAvatar', user.avatar) 
            store.commit('setRoleKey', user.rlky)
            store.commit('setTwoFA', user.twoFA)
            store.commit('setAppNotification', user.appNotification)
            store.commit('setEmailNotification', user.emailNotification)
            store.commit('setTwoFAVerified', false)
            store.commit('setNewDevice', user.newDevice)

            //personalized settings
            store.commit('setTheme', user.theme)
            store.commit('setColor', user.color)
            store.commit('setLeftNavMini', user.leftNavMini)
            store.commit('setLeftNavToggle', user.leftNavToggle)
            store.commit('setRightNavMini', user.rightNavMini)
            store.commit('setRightNavToggle', user.rightNavToggle)
            
            store.commit('setToken', user.token)      

            //team details           
            store.commit('setTeamId', user.teamId)   
            store.commit('setTeamName', user.team) 
            store.commit('setTeamLogo', user.teamLogoFileName)

            //company details
            store.commit('setCompanyId', user.companyId) //using encrypted companyId
            store.commit('setCompanyName', user.company)
            store.commit('setCompanyAccount', response.data.account)
            store.commit('setCompanyLogo', user.companyLogoFileName)

            store.commit('setTeamCount', user.teamCount)
            store.commit('setUserCount', user.userCount)
            store.commit('setAccountName', user.accountName)
            store.commit('setAccountKey', user.accountKey)
        }catch(error){
            console.log('saveUserState: ', error)
        }
    },   
    loggedIn () {
        return !!localStorage.token 
    },
    requiresChangePassword() {
        return !store.state.changedPassword
    },
    onBoarded() {
        return store.state.onBoarded
    },
    deleteToken() {
        store.commit('setToken', null)
        delete localStorage.token
        delete localStorage.refreshToken
        axios.defaults.headers["Authorization"] = ''
        axios.defaults.headers["session_id"] = ''
    },
    clearLoginDetails() {
        store.commit('setPassword', '')
    },
    clearAuth() {
        axios.defaults.headers["Authorization"] = ''
        axios.defaults.headers["session_id"] = ''

        delete localStorage.token
        delete localStorage.refreshToken
        delete localStorage.sessionId
        
        store.commit('setPassword', '')
        store.commit('setOnBoarded', '')
        store.commit('setChangedPassword', '')
        store.commit('setMemberCount', '')
        store.commit('setIsLinkedAccount', false)

        //user details
        store.commit('setUserId', '')
        store.commit('setParentUserId', '')
        store.commit('setUserName', '') 
        store.commit('setName', '') 
        // store.commit('setFirstName', '')
        // store.commit('setLastName', '')        
        store.commit('setEmail', '')
        store.commit('setAvatar', '') 
        store.commit('setRoleKey', '')
        store.commit('setTwoFA', null)
        store.commit('setTwoFAVerified', null)
        store.commit('setNewDevice', null)

        //personalized settings
        store.commit('setTheme', '')
        store.commit('setColor', '')
        store.commit('setLeftNavMini', '')
        store.commit('setLeftNavToggle', '')
        store.commit('setRightNavMini', '')
        store.commit('setRightNavToggle', '')
        store.commit('setToken', '')      
        store.commit('setTokenExpiration', '')    
        
        //team details           
        store.commit('setTeamId', '')
        store.commit('setTeamName', '') 
        store.commit('setTeamLogo', '')
        //company details
        store.commit('setCompanyId', '')
        store.commit('setCompanyName', '')
        store.commit('setCompanyLogo', '')
        store.commit('setCompanyAccount', '')

        store.commit('setGeoAddress', '')
        store.commit('setGeoAddressAsOf', '')
        
        store.commit('setTeamCount', null)
        store.commit('setUserCount', null)
        store.commit('setAccountName', null)
        store.commit('setAccountKey', null)
        store.commit('removeNotifCount', null)
        // store.commit('setUserAppsList', null)    //DON'T CLEAR, used in personalized public notifications

        store.commit('setSelectedTeamName', null)
        store.commit('setSelectedTeamId', null)
        store.commit('setSelectedTeamRole', null)
        store.commit('setSelectedTeamPermissions', null)
    },
    async logout(data) {
        if (data) {
            try {
                await userApi.logout(data)
            }catch(error){
                throw error
            }finally{
                this.clearAuth()
                if (data.logoutCode == 'Change Password') {
                    router.push(`/login`) 
                }else{
                    router.push(`/home?action=${data.logoutCode}`) 
                }
            }
        }
    }
}